// extracted by mini-css-extract-plugin
export var container = "_6a-0";
export var containerTopRight = "_6a-1";